import _objectSpread from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { css as _css } from "styled-components";
import { keyframes as _keyframes } from "styled-components";
import _styled from "styled-components";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["animation: ", " 2s ease-out infinite 0.5s;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  50% {\n    opacity: 0.33;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useMemo, useState, useEffect } from "react";
import CompressorIconAsset from "@smartheat/common/png/compressor@112x112.png";
import { ReactComponent as OkayIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/successcircle.svg";
import { formatTemperature } from "../../../../utils/formatTemperature";
import { useRegistersSubscription } from "../../../DeviceData/useRegistersSubscription";
import { useRegisterConfigQuery } from "../../../DeviceData/useRegisterConfigQuery";
import { useUserAppConfig } from "../../../DeviceData/useUserAppConfig";
import { ConfirmModal } from "../../ToggleGroup/ConfirmModal";
import { ConfirmButton } from "../../ToggleGroup/ConfirmButton";
import { useRegSlot, useRegister } from "../../../hooks/useRegister";
import { HeatChillToggle } from "./HeatChillToggle";
import { PowerButton } from "./PowerButton";
import { Alarms } from "./Alarms";

var OneCenterElement = _styled.div.withConfig({
  displayName: "Hw3Page__OneCenterElement",
  componentId: "tt5ggz-0"
})(["--state-color-red:#dd4e4e;--state-color-blue:#4d9adf;--state-color-gray:#a3a3a3;--state-active-color:", ";", " position:relative;display:flex;justify-content:center;margin:64px auto 0;width:368px;height:368px;@media screen and (max-width:419px){width:288px;height:288px;margin:40px auto 0;}"], function (p) {
  return p.isInHeatMode ? "var(--state-color-red)" : "var(--state-color-blue)";
}, function (p) {
  return p.isActive ? "" : "--state-inactive-color-or: var(--state-color-gray);";
});

var Expanded = _styled.div.withConfig({
  displayName: "Hw3Page__Expanded",
  componentId: "tt5ggz-1"
})(["flex:1;display:flex;flex-direction:column;justify-content:center;align-items:center;"]);

var HeatChillContainer = _styled.div.withConfig({
  displayName: "Hw3Page__HeatChillContainer",
  componentId: "tt5ggz-2"
})(["position:relative;"]);

var PowerButtonContainer = _styled.div.withConfig({
  displayName: "Hw3Page__PowerButtonContainer",
  componentId: "tt5ggz-3"
})(["position:relative;display:flex;justify-content:center;margin-bottom:8px;"]);

var CircleElement = _styled.div.withConfig({
  displayName: "Hw3Page__CircleElement",
  componentId: "tt5ggz-4"
})(["position:absolute;height:320px;width:320px;top:50%;left:50%;transform:translate(-50%,-50%);background-color:var(--state-color-", ");border-radius:50%;display:flex;justify-content:center;opacity:", ";transition:background-color 0.2s;@media screen and (max-width:419px){height:240px;width:240px;}"], function (_ref) {
  var color = _ref.color;
  return color;
}, function (props) {
  return props.disabled ? 0.3 : 1;
});

var CircleContent = _styled.div.withConfig({
  displayName: "Hw3Page__CircleContent",
  componentId: "tt5ggz-5"
})(["color:white;width:230px;display:flex;flex-direction:column;"]);

var CenteredMessage = _styled.div.withConfig({
  displayName: "Hw3Page__CenteredMessage",
  componentId: "tt5ggz-6"
})(["font-size:36px;text-align:center;display:flex;height:100%;align-items:center;justify-content:center;@media screen and (max-width:419px){font-size:30px;}"]);

var TemperatureLeftRight = _styled.div.withConfig({
  displayName: "Hw3Page__TemperatureLeftRight",
  componentId: "tt5ggz-7"
})(["display:flex;font-size:28px;width:230px;margin:50px auto 0 auto;div{flex:1 1 50%;text-align:center;}@media screen and (max-width:419px){font-size:22px;width:180px;margin-top:32px;}"]);

var blinkAnimation = _keyframes(_templateObject());

var TemperatureCenter = _styled.div.withConfig({
  displayName: "Hw3Page__TemperatureCenter",
  componentId: "tt5ggz-8"
})(["display:flex;justify-content:center;margin-top:30px;font-size:46px;", " @media screen and (max-width:419px){font-size:40px;margin-top:8px;}"], function (p) {
  return p.blink ? _css(_templateObject2(), blinkAnimation) : '';
});

var ErrorContent = _styled.div.withConfig({
  displayName: "Hw3Page__ErrorContent",
  componentId: "tt5ggz-9"
})(["font-size:20px;color:white;width:270px;display:flex;flex-direction:column;align-items:center;justify-content:space-between;"]);

var BlockErrorMessage = _styled.div.withConfig({
  displayName: "Hw3Page__BlockErrorMessage",
  componentId: "tt5ggz-10"
})(["font-size:30px;margin-top:65px;text-align:center;@media screen and (max-width:419px){font-size:24px;margin-top:45px;}"]);

var ErrorInfo = _styled.div.withConfig({
  displayName: "Hw3Page__ErrorInfo",
  componentId: "tt5ggz-11"
})(["margin-bottom:48px;@media screen and (max-width:419px){margin-bottom:32px;}"]);

var NumberRow = _styled.div.withConfig({
  displayName: "Hw3Page__NumberRow",
  componentId: "tt5ggz-12"
})(["font-size:24px;text-align:center;"]);

var TextRow = _styled.div.withConfig({
  displayName: "Hw3Page__TextRow",
  componentId: "tt5ggz-13"
})(["font-size:22px;text-align:center;@media screen and (max-width:419px){font-size:18px;padding:0 24px;}"]);

var CompressorIndicatorImage = _styled.img.withConfig({
  displayName: "Hw3Page__CompressorIndicatorImage",
  componentId: "tt5ggz-14"
})(["position:absolute;left:50%;transform:translateX(-50%);top:10px;width:28px;height:28px;"]);

var CompressorIndicator = function CompressorIndicator() {
  return /*#__PURE__*/React.createElement(CompressorIndicatorImage, {
    src: CompressorIconAsset,
    alt: ""
  });
};

var sizeIconModal = 60;
export function Hw3Page() {
  var userAppConfig = useUserAppConfig();
  var hw3RawConfig = userAppConfig && userAppConfig.hw3;
  var hw3Config = useMemo(function () {
    return prepareConfig(hw3RawConfig);
  }, [hw3RawConfig]);
  var allRegisters = useMemo(function () {
    return ["motohoursBlockState"].concat(_toConsumableArray(getRegistersFromConfig(hw3Config)));
  }, [hw3Config]);

  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registersConfig = useRegisterConfigQuery(allRegisters);
  var motohoursBlockState = registersData.motohoursBlockState;

  if (motohoursBlockState === undefined || !registersConfig || !userAppConfig) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      color: "gray"
    }, /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(CenteredMessage, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."))));
  }

  if (motohoursBlockState) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      color: "gray"
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u0422\u0435\u043F\u043B\u043E\u0432\u043E\u0439 \u043D\u0430\u0441\u043E\u0441 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  if (!hw3Config) {
    return /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      color: "gray"
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(BlockErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: \u041A\u041F"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр")))));
  }

  return /*#__PURE__*/React.createElement(UserModeContent, {
    registersData: registersData,
    registersConfig: registersConfig,
    config: hw3Config
  });
}

function UserModeContent(_ref2) {
  var registersConfig = _ref2.registersConfig,
      registersData = _ref2.registersData,
      config = _ref2.config;
  var modeConfig = config.modeConfig;
  var deviceState = useRegSlot(config.deviceState, registersData, registersConfig);
  var compressorStatus = useRegister(config.compressorStatus, registersData, registersConfig);
  var leftSlot = useRegister(config.leftSlot, registersData, registersConfig);
  var rightSlot = useRegister(config.rightSlot, registersData, registersConfig);
  var heatChillState = useRegSlot(modeConfig.state, registersData, registersConfig);
  var heatSetting = useRegister(modeConfig.heatSetting, registersData, registersConfig);
  var chillSetting = useRegister(modeConfig.chillSetting, registersData, registersConfig);
  var isInHeatMode = heatChillState.value === undefined ? undefined : heatChillState.value === modeConfig.heatValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OneCenterElement, {
    isActive: deviceState.value,
    isInHeatMode: isInHeatMode
  }, /*#__PURE__*/React.createElement(CircleElement, {
    color: getCircleColor(config, deviceState.value, heatChillState.value)
  }, /*#__PURE__*/React.createElement(CircleContent, null, /*#__PURE__*/React.createElement(TemperatureLeftRight, null, /*#__PURE__*/React.createElement("div", null, config.leftSlot ? formatTemperature(Math.round(leftSlot)) : ""), /*#__PURE__*/React.createElement("div", null, config.rightSlot ? formatTemperature(Math.round(rightSlot)) : "")), /*#__PURE__*/React.createElement(TemperatureCenter, null, heatChillState.value === undefined ? "\xA0" : formatTemperature(Math.round(isInHeatMode ? heatSetting : chillSetting))), /*#__PURE__*/React.createElement(Expanded, null, /*#__PURE__*/React.createElement(HeatChillToggleField, {
    config: config,
    heatChillState: heatChillState
  })), deviceState.value !== undefined && !!config.hasPowerSwitch && /*#__PURE__*/React.createElement(PowerButtonField, {
    config: config,
    deviceState: deviceState
  })), compressorStatus && /*#__PURE__*/React.createElement(CompressorIndicator, null))), !!config.showAlarms && /*#__PURE__*/React.createElement(Alarms, null), !!config.extraValues && config.extraValues.length > 0 && /*#__PURE__*/React.createElement(ExtraValues, {
    values: config.extraValues,
    registersConfig: registersConfig,
    registersData: registersData
  }));
}

function HeatChillToggleField(_ref3) {
  var config = _ref3.config,
      heatChillState = _ref3.heatChillState;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      openedModal = _useState2[0],
      setOpenedModal = _useState2[1];

  var isInHeatMode = heatChillState.value === config.modeConfig.heatValue;
  var handleHeatChillChange = useCallback(function () {
    setOpenedModal(isInHeatMode ? "ConfirmChill" : "ConfirmHeat");
  }, [isInHeatMode]);
  var handleHeatConfirmed = useCallback(function () {
    setOpenedModal(null);
    heatChillState.setValue(config.modeConfig.heatValue);
  }, [heatChillState]);
  var handleChillConfirmed = useCallback(function () {
    setOpenedModal(null);
    heatChillState.setValue(config.modeConfig.chillValue);
  }, [heatChillState]);
  var onModalClose = useCallback(function () {
    setOpenedModal(null);
  }, []);
  return /*#__PURE__*/React.createElement(HeatChillContainer, null, /*#__PURE__*/React.createElement(HeatChillToggle, {
    on: isInHeatMode,
    indeterminate: heatChillState.value === undefined,
    syncing: heatChillState.syncing,
    onChange: handleHeatChillChange
  }), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "ConfirmHeat",
    onClose: onModalClose,
    titleText: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0440\u0435\u0436\u0438\u043C?",
    contentText: "\u041D\u0430\u0447\u0430\u0442\u044C \u0442\u043E\u043F\u0438\u0442\u044C \u0441\u0435\u0439\u0447\u0430\u0441"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: handleHeatConfirmed
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "ConfirmChill",
    onClose: onModalClose,
    titleText: "Переключить режим?",
    contentText: "Включить охлаждение"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: handleChillConfirmed
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))));
}

function PowerButtonField(_ref4) {
  var config = _ref4.config,
      deviceState = _ref4.deviceState;

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      openedModal = _useState4[0],
      setOpenedModal = _useState4[1];

  var isOn = deviceState.value === true;
  var handleChange = useCallback(function () {
    setOpenedModal(isOn ? "ConfirmOff" : "ConfirmOn");
  }, [isOn]);
  var handleOnConfirmed = useCallback(function () {
    setOpenedModal(null);
    deviceState.setValue(true);
  }, [deviceState]);
  var handleOffConfirmed = useCallback(function () {
    setOpenedModal(null);
    deviceState.setValue(false);
  }, [deviceState]);
  var onModalClose = useCallback(function () {
    setOpenedModal(null);
  }, []);
  return /*#__PURE__*/React.createElement(PowerButtonContainer, null, /*#__PURE__*/React.createElement(PowerButton, {
    isActive: isOn,
    syncing: deviceState.syncing,
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "ConfirmOn",
    onClose: onModalClose,
    titleText: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0441\u0435\u0439\u0447\u0430\u0441?"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: handleOnConfirmed
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))), /*#__PURE__*/React.createElement(ConfirmModal, {
    isOpen: openedModal === "ConfirmOff",
    onClose: onModalClose,
    titleText: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0441\u0435\u0439\u0447\u0430\u0441?"
  }, /*#__PURE__*/React.createElement(ConfirmButton, {
    buttonLabel: "Да",
    onClick: handleOffConfirmed
  }, /*#__PURE__*/React.createElement(OkayIcon, {
    width: sizeIconModal,
    height: sizeIconModal
  }))));
}

var ExtraGridContainer = _styled.div.withConfig({
  displayName: "Hw3Page__ExtraGridContainer",
  componentId: "tt5ggz-15"
})(["padding:0 10px 32px;"]);

var ExtraGrid = _styled.div.withConfig({
  displayName: "Hw3Page__ExtraGrid",
  componentId: "tt5ggz-16"
})(["display:flex;justify-content:center;flex-wrap:wrap;flex-direction:reverse;gap:20px 0;@media screen and (max-width:419px){width:340px;}"]);

var ExtraGridCell = _styled.div.withConfig({
  displayName: "Hw3Page__ExtraGridCell",
  componentId: "tt5ggz-17"
})(["flex:0 0 50%;box-sizing:border-box;padding:0 10px;"]);

var ExtraValueBox = _styled.div.withConfig({
  displayName: "Hw3Page__ExtraValueBox",
  componentId: "tt5ggz-18"
})(["background-color:#4d9adf;color:white;border-radius:8px;padding:8px;display:flex;flex-direction:column;gap:8px;"]);

var ExtraValueTitle = _styled.div.withConfig({
  displayName: "Hw3Page__ExtraValueTitle",
  componentId: "tt5ggz-19"
})(["text-align:center;font-size:20px;"]);

var ExtraValue = _styled.div.withConfig({
  displayName: "Hw3Page__ExtraValue",
  componentId: "tt5ggz-20"
})(["text-align:center;font-size:28px;"]);

function ExtraValues(_ref5) {
  var values = _ref5.values,
      registersData = _ref5.registersData,
      registersConfig = _ref5.registersConfig;
  return /*#__PURE__*/React.createElement(ExtraGridContainer, null, /*#__PURE__*/React.createElement(ExtraGrid, null, values.map(function (_ref6) {
    var title = _ref6.title,
        source = _ref6.source;
    return /*#__PURE__*/React.createElement(ExtraValuesItem, {
      title: title,
      source: source,
      registersConfig: registersConfig,
      registersData: registersData
    });
  })));
}

function ExtraValuesItem(_ref7) {
  var title = _ref7.title,
      source = _ref7.source,
      registersConfig = _ref7.registersConfig,
      registersData = _ref7.registersData;
  var register = useRegister(source, registersData, registersConfig);
  return /*#__PURE__*/React.createElement(ExtraGridCell, null, /*#__PURE__*/React.createElement(ExtraValueBox, null, /*#__PURE__*/React.createElement(ExtraValueTitle, null, title), /*#__PURE__*/React.createElement(ExtraValue, null, formatTemperature(Math.round(register)))));
}

function getCircleColor(config, deviceState, heatChillState) {
  if (config.deviceState && !deviceState) {
    return "gray";
  }

  return heatChillState === config.modeConfig.heatValue ? "red" : "blue";
}

function getRegistersFromConfig(config) {
  var modeRegisters = [];
  var extraData = [];

  if (config.mode === "HeatChill") {
    modeRegisters = [config.modeConfig.state, config.modeConfig.heatSetting, config.modeConfig.chillSetting];
  }

  if (config.extraValues) {
    extraData = config.extraValues.map(function (_ref8) {
      var source = _ref8.source;
      return source;
    });
  }

  return [config.deviceState, config.compressorStatus, config.leftSlot, config.rightSlot].concat(_toConsumableArray(modeRegisters), _toConsumableArray(extraData)).filter(function (item) {
    return !!item;
  });
}

function prepareConfig(raw_config) {
  if (!raw_config) {
    console.error("hw3 config is missing");
    return undefined;
  }

  if (!raw_config.mode) {
    console.error("`mode` is not defined in hw3 config");
    return undefined;
  }

  var modeProp = raw_config.mode,
      props = _objectWithoutProperties(raw_config, ["mode"]);

  var modeKeys = Object.keys(modeProp);

  if (modeKeys.length !== 1) {
    console.error("Unexpected keys in mode");
    return undefined;
  }

  var _modeKeys = _slicedToArray(modeKeys, 1),
      mode = _modeKeys[0];

  return _objectSpread(_objectSpread({}, props), {}, {
    mode: mode,
    modeConfig: modeProp[mode]
  });
}